import React, { FormEvent, Ref, lazy } from 'react';

import { Container } from '../forms/Input';

const SingleFieldDateInput = lazy(() => import(
  /* webpackChunkName: "datepicker" */
  /* webpackPrefetch: true */
  '../SingleFieldForm/SingleFieldDateInput'
  ));


interface Props {
  label: string;
  value: Date | null;
  onChange: (value: Date | null) => void;
  onInvalid?: (e: FormEvent) => void,
  required?: boolean;
  errorRef?: Ref<HTMLDivElement>;
}

const DateFormInput = ({
  label,
  value,
  onChange,
  onInvalid,
  required,
  errorRef
}: Props) => {
  return <Container $zIndex={150} $growing={true}>
    <SingleFieldDateInput
      value={value}
      onChange={onChange}
      onInvalid={onInvalid}
      onSubmit={() => null}
      valid={true}
      eventForm={true}
      required={required}
      errorRef={errorRef}
    />
  </Container>

};

export default DateFormInput;
